import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import GalleryPage from '../pages/gallery/page';
import ContactPage from '../pages/contact/page';

// Installation & Upgrades
import InstallationUpgradesPage from '../pages/services/installation-upgrades/page';
import ElectricalInstallationsPage from '../pages/services/installation-upgrades/electrical-installations/page';
import RewiringPage from '../pages/services/installation-upgrades/rewiring/page';
import ConsumerUnitUpgradesPage from '../pages/services/installation-upgrades/consumer-unit-upgrades/page';
import LightingInstallationPage from '../pages/services/installation-upgrades/lighting-installation/page';
import LedLightingUpgradesPage from '../pages/services/installation-upgrades/led-lighting-upgrades/page';
import OutdoorGardenLightingPage from '../pages/services/installation-upgrades/outdoor-garden-lighting/page';
import SecurityLightingPage from '../pages/services/installation-upgrades/security-lighting/page';
import SocketSwitchInstallationPage from '../pages/services/installation-upgrades/socket-switch-installation/page';
import EvChargerInstallationPage from '../pages/services/installation-upgrades/ev-charger-installation/page';
import SmartHomeInstallationsPage from '../pages/services/installation-upgrades/smart-home-installations/page';
import HomeAutomationPage from '../pages/services/installation-upgrades/home-automation/page';
import HeatingControlsPage from '../pages/services/installation-upgrades/heating-controls/page';
import ElectricShowerInstallationPage from '../pages/services/installation-upgrades/electric-shower-installation/page';
import KitchenElectricalPage from '../pages/services/installation-upgrades/kitchen-electrical/page';

// Repair & Maintenance
import RepairMaintenancePage from '../pages/services/repair-maintenance/page';
import ElectricalRepairsPage from '../pages/services/repair-maintenance/electrical-repairs/page';
import FaultFindingPage from '../pages/services/repair-maintenance/fault-finding/page';
import TrippingCircuitsPage from '../pages/services/repair-maintenance/tripping-circuits/page';
import FuseBoxRepairsPage from '../pages/services/repair-maintenance/fuse-box-repairs/page';
import LightingRepairsPage from '../pages/services/repair-maintenance/lighting-repairs/page';
import SocketSwitchRepairsPage from '../pages/services/repair-maintenance/socket-switch-repairs/page';
import EmergencyCallOutsPage from '../pages/services/repair-maintenance/emergency-call-outs/page';
import MaintenanceContractsPage from '../pages/services/repair-maintenance/maintenance-contracts/page';
import ApplianceRepairsPage from '../pages/services/repair-maintenance/appliance-repairs/page';

// Safety & Compliance
import SafetyCompliancePage from '../pages/services/safety-compliance/page';
import EicrReportsPage from '../pages/services/safety-compliance/eicr-reports/page';
import PatTestingPage from '../pages/services/safety-compliance/pat-testing/page';
import FireAlarmTestingPage from '../pages/services/safety-compliance/fire-alarm-testing/page';
import EmergencyLightingPage from '../pages/services/safety-compliance/emergency-lighting/page';
import LandlordElectricalSafetyPage from '../pages/services/safety-compliance/landlord-electrical-safety/page';
import PrePurchaseSurveyPage from '../pages/services/safety-compliance/pre-purchase-survey/page';
import SmokeCOAlarmsPage from '../pages/services/safety-compliance/smoke-co-alarms/page';
import HmoCompliancePage from '../pages/services/safety-compliance/hmo-compliance/page';
import SolarPvInspectionPage from '../pages/services/safety-compliance/solar-pv-inspection/page';
import ElectricalSafetySurveysPage from '../pages/services/safety-compliance/electrical-safety-surveys/page';
import CommercialCompliancePage from '../pages/services/safety-compliance/commercial-compliance/page';
import RemedialWorksPage from '../pages/services/safety-compliance/remedial-works/page';

// Commercial
import CommercialPage from '../pages/services/commercial/page';
import CommercialInstallationsPage from '../pages/services/commercial/commercial-installations/page';
import ThreePhasePowerPage from '../pages/services/commercial/three-phase-power/page';
import CommercialRewiringPage from '../pages/services/commercial/commercial-rewiring/page';
import OfficeFitOutPage from '../pages/services/commercial/office-fit-out/page';
import DataCablingPage from '../pages/services/commercial/data-cabling/page';
import CommercialLightingPage from '../pages/services/commercial/commercial-lighting/page';
import CommercialEvChargingPage from '../pages/services/commercial/commercial-ev-charging/page';
import RetailElectricalPage from '../pages/services/commercial/retail-electrical/page';
import WarehouseIndustrialPage from '../pages/services/commercial/warehouse-industrial/page';
import CommercialMaintenancePage from '../pages/services/commercial/commercial-maintenance/page';
import CommercialEicrPage from '../pages/services/commercial/commercial-eicr/page';

const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/gallery', element: <GalleryPage /> },
  { path: '/contact', element: <ContactPage /> },

  // Installation & Upgrades
  { path: '/services/installation-upgrades', element: <InstallationUpgradesPage /> },
  { path: '/services/installation-upgrades/electrical-installations', element: <ElectricalInstallationsPage /> },
  { path: '/services/installation-upgrades/rewiring', element: <RewiringPage /> },
  { path: '/services/installation-upgrades/consumer-unit-upgrades', element: <ConsumerUnitUpgradesPage /> },
  { path: '/services/installation-upgrades/lighting-installation', element: <LightingInstallationPage /> },
  { path: '/services/installation-upgrades/led-lighting-upgrades', element: <LedLightingUpgradesPage /> },
  { path: '/services/installation-upgrades/outdoor-garden-lighting', element: <OutdoorGardenLightingPage /> },
  { path: '/services/installation-upgrades/security-lighting', element: <SecurityLightingPage /> },
  { path: '/services/installation-upgrades/socket-switch-installation', element: <SocketSwitchInstallationPage /> },
  { path: '/services/installation-upgrades/ev-charger-installation', element: <EvChargerInstallationPage /> },
  { path: '/services/installation-upgrades/smart-home-installations', element: <SmartHomeInstallationsPage /> },
  { path: '/services/installation-upgrades/home-automation', element: <HomeAutomationPage /> },
  { path: '/services/installation-upgrades/heating-controls', element: <HeatingControlsPage /> },
  { path: '/services/installation-upgrades/electric-shower-installation', element: <ElectricShowerInstallationPage /> },
  { path: '/services/installation-upgrades/kitchen-electrical', element: <KitchenElectricalPage /> },

  // Repair & Maintenance
  { path: '/services/repair-maintenance', element: <RepairMaintenancePage /> },
  { path: '/services/repair-maintenance/electrical-repairs', element: <ElectricalRepairsPage /> },
  { path: '/services/repair-maintenance/fault-finding', element: <FaultFindingPage /> },
  { path: '/services/repair-maintenance/tripping-circuits', element: <TrippingCircuitsPage /> },
  { path: '/services/repair-maintenance/fuse-box-repairs', element: <FuseBoxRepairsPage /> },
  { path: '/services/repair-maintenance/lighting-repairs', element: <LightingRepairsPage /> },
  { path: '/services/repair-maintenance/socket-switch-repairs', element: <SocketSwitchRepairsPage /> },
  { path: '/services/repair-maintenance/emergency-call-outs', element: <EmergencyCallOutsPage /> },
  { path: '/services/repair-maintenance/maintenance-contracts', element: <MaintenanceContractsPage /> },
  { path: '/services/repair-maintenance/appliance-repairs', element: <ApplianceRepairsPage /> },

  // Safety & Compliance
  { path: '/services/safety-compliance', element: <SafetyCompliancePage /> },
  { path: '/services/safety-compliance/eicr-reports', element: <EicrReportsPage /> },
  { path: '/services/safety-compliance/pat-testing', element: <PatTestingPage /> },
  { path: '/services/safety-compliance/fire-alarm-testing', element: <FireAlarmTestingPage /> },
  { path: '/services/safety-compliance/emergency-lighting', element: <EmergencyLightingPage /> },
  { path: '/services/safety-compliance/landlord-electrical-safety', element: <LandlordElectricalSafetyPage /> },
  { path: '/services/safety-compliance/pre-purchase-survey', element: <PrePurchaseSurveyPage /> },
  { path: '/services/safety-compliance/smoke-co-alarms', element: <SmokeCOAlarmsPage /> },
  { path: '/services/safety-compliance/hmo-compliance', element: <HmoCompliancePage /> },
  { path: '/services/safety-compliance/solar-pv-inspection', element: <SolarPvInspectionPage /> },
  { path: '/services/safety-compliance/electrical-safety-surveys', element: <ElectricalSafetySurveysPage /> },
  { path: '/services/safety-compliance/commercial-compliance', element: <CommercialCompliancePage /> },
  { path: '/services/safety-compliance/remedial-works', element: <RemedialWorksPage /> },

  // Commercial
  { path: '/services/commercial', element: <CommercialPage /> },
  { path: '/services/commercial/commercial-installations', element: <CommercialInstallationsPage /> },
  { path: '/services/commercial/three-phase-power', element: <ThreePhasePowerPage /> },
  { path: '/services/commercial/commercial-rewiring', element: <CommercialRewiringPage /> },
  { path: '/services/commercial/office-fit-out', element: <OfficeFitOutPage /> },
  { path: '/services/commercial/data-cabling', element: <DataCablingPage /> },
  { path: '/services/commercial/commercial-lighting', element: <CommercialLightingPage /> },
  { path: '/services/commercial/commercial-ev-charging', element: <CommercialEvChargingPage /> },
  { path: '/services/commercial/retail-electrical', element: <RetailElectricalPage /> },
  { path: '/services/commercial/warehouse-industrial', element: <WarehouseIndustrialPage /> },
  { path: '/services/commercial/commercial-maintenance', element: <CommercialMaintenancePage /> },
  { path: '/services/commercial/commercial-eicr', element: <CommercialEicrPage /> },

  { path: '*', element: <NotFound /> },
];

export default routes;
